import React, { useState } from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import Button from '../../../../Components/Button/Button';
import {
	ToothRestoration,
	ToothRestorationType,
} from '../../../../graphql/graphql';
import DENTModalOverviewRestorationCrownButtons from '../DENTModalOverviewRestorationButtons/DENTModalOverviewRestorationCrownButtons';
import { useDENTContext } from '../../Services/DENTContext';
import styles from './DENTToothQuickCrownModal.module.scss';

const DENTToothQuickCrownModal = () => {
	const { t } = useTranslation();
	const [values, setValues] = useState<ToothRestoration | undefined>();
	const { handleUpdateToothBulk } = useDENTContext();

	const handleSubmit = async () => {
		handleUpdateToothBulk({
			restoration: {
				type: ToothRestorationType.Crown,
				...values,
			},
		});
	};

	return (
		<>
			<h2>
				{t('patientTreatment.meddiDENT.dentalCross.restorationModal.crown')}
			</h2>
			<DENTModalOverviewRestorationCrownButtons
				values={values}
				setValues={setValues}
			/>
			<Button
				className={styles.button}
				title={'base.shared.form.send'}
				onClick={handleSubmit}
			/>
		</>
	);
};

export default DENTToothQuickCrownModal;
